export default {
  namespaced: true,
  state: {
    rooms: []
  },
  getters: {
    all: state => state.rooms,
    getByCornerId: state => cornerId => {
      return _.filter(state.rooms, ["corner_id", cornerId])
    },
    getBySlug: state => slug => {
      return _.find(state.rooms, ["slug", slug]) || {}
    }
  },
  mutations: {
    setRooms(state, rooms) {
      state.rooms = rooms
    }
  },
  actions: {
    /**
     * ルームの取得
     * @param {object} context
     * @param {string} slug
     * @returns {Promise<void>}
     */
    async getRooms(context, slug) {
      await this._vm.$axios
        .get(`events/${slug}/rooms`)
        .then(response => {
          context.commit("setRooms", response.data.rooms)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
